import axios from 'axios';

const commonConfig = {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': document.head.querySelector("[name=csrf-token]").content,
    },
};

const axiosInstance = axios.create({
    ...commonConfig,
    headers: {
        ...commonConfig.headers,
        'Content-Type': 'application/json',
    },
});

export const axiosMultipartFormDataInstance = axios.create({
    ...commonConfig,
    headers: {
        ...commonConfig.headers,
        'Content-Type': 'multipart/form-data',
    },
});

export default axiosInstance;

